import { defineStore } from 'pinia'
import { getFullWay } from './services/getFullWay'
import { getTSPWay } from './services/getTSPWay'
import { getEmployeeList, getStorages } from './services/bitrixcrm'

export const useRoutingStore = defineStore('routing', {
  state: () => ({
    RLName: null,
    RLWaypoints: [
      //{title: 'Тестовая точка 1', coordinates: [lng, lat], ID: '11111'} // пример точки
    ],
    //RLStartPoint: null,
    RLStartPoint: {
      ID: 0,
      name: '',
      title: '',
      address: '',
      coordinates: [0, 0]

      // ID: 3,
      // name: 'Ломакина Ирина Николаевна (с Княжево, ул Ленина, д. 65)',
      // title: 'Ломакина Ирина Николаевна (с Княжево, ул Ленина, д. 65)',
      // address: '625506, Тюменская область, р-н Тюменский, с Княжево, ул Ленина, д. 65',
      // coordinates: [65.748199, 56.868507]
    },
    RLZoomPoint: null,
    RLRouteOptimized: false,
    RLRouteLength: null,
    RLRouteDuration: null,
    IsCycle: false,
    RLRouteLineCoordinates: null,
    employee: [],
    RLDriver: null,
    clickedAddress: null,
    storages: [],
    searchStatus: false,
    selectedPoints: [],
    inputStartTimeStore: null,
    fullDuration: null,
    requestsCount: 0
  }),
  actions: {
    setInputStartTimeStore (value) {
      this.inputStartTimeStore = value
    },
    setFullDuration (value) {
      this.fullDuration = value
    },

    addSelectedPoints (item) {
      this.selectedPoints = [...this.selectedPoints, item]
      // this.selectedPoints.push(item)
    },
    deleteSelectedPoints (item, clean = false) {
      clean ? (this.selectedPoints = []) : null
      this.selectedPoints = this.selectedPoints.filter(elem => elem.ID !== item.ID)
    },
    setSelectedPoints (points = []) {
      this.selectedPoints = points
    },
    setSearchStatus (value) {
      this.searchStatus = value
    },

    flip () {
      if (this.RLWaypoints.includes(this.RLStartPoint)) {
        let road = this.RLWaypoints.filter(item => item.ID !== this.RLStartPoint.ID)
        let reversedRoad = road.reverse()
        this.RLWaypoints = [...reversedRoad, this.RLStartPoint]
      } else {
        this.RLWaypoints = this.RLWaypoints.reverse()
      }
    },
    editCoordinates (coords, item) {
      this.RLWaypoints.forEach(elem => {
        if (elem.ID === item) {
          elem.coordinates = [...coords]
        }
      })
    },
    setClickedAddress (item) {
      this.clickedAddress = item.ID
    },
    changeDriver (value) {
      this.RLDriver = value
    },
    clearDriver () {
      this.RLDriver = null
    },
    setRLRouteLineCoordinates (value) {
      this.RLRouteLineCoordinates = value
    },
    setCycle (value) {
      this.IsCycle = value
      if (value) {
        this.RLWaypoints = [...this.RLWaypoints, this.RLStartPoint]
      } else {
        this.RLWaypoints = this.RLWaypoints.filter(item => item.ID !== this.RLStartPoint.ID)
      }
    },
    setName (value) {
      this.RLName = value
    },
    setWaypoints (waypoints = []) {
      this.RLWaypoints = waypoints
    },
    addWaypoint (pointObj) {
      const found = this.RLWaypoints.find(element => pointObj['ID'] == element['ID'])
      if (!found) {
        this.RLWaypoints = [...this.RLWaypoints, pointObj]
      }
    },
    deleteWaypoint (pointObj) {
      this.RLWaypoints = this.RLWaypoints.filter(point => point['ID'] !== pointObj['ID'])
    },

    swapPoints (index1, index2) {
      const pointsCopy = [...this.RLWaypoints.map(point => ({ ...point }))]
      const tmpElement = pointsCopy.splice(index1, 1)
      pointsCopy.splice(index2, 0, ...tmpElement)
      this.RLWaypoints = pointsCopy
    },
    setZoomPoint (pointObj) {
      this.RLZoomPoint = pointObj.coordinates
    },
    switchOptimizeState (value = true) {
      this.RLRouteOptimized = value
    },

    setRouteLength (value) {
      this.RLRouteLength = value
    },
    setRouteDuration (value) {
      this.RLRouteDuration = value
    },
    setStartPoint (pointObj) {
      this.RLStartPoint = pointObj
    },

    async setEmployee () {
      try {
        this.employee = await getEmployeeList()
      } catch (error) {}
    },
    async setStorages () {
      try {
        this.storages = await getStorages()
      } catch (error) {}
    },
    clearStore () {
      this.RLName = null
      this.RLTime = null
      this.RLWaypoints = []
      this.RLStartPoint = null
      this.RLZoomPoint = null
      this.RLRouteOptimized = false
    },
    checkStoreData () {
      const problems = []
      if (!this.selectedPoints.length) {
        problems.push('Выберите точки маршрута')
      }
      if (!this.RLStartPoint) {
        problems.push('Выберите склад')
      }
      //if (!this.RLDriver) {problems.push('Выберите водителя')}
      if (problems.length > 0) {
        throw new Error(`${problems.join(', ')}`)
      }
    }
  },
  getters: {
    async getRoutePoints () {
      try {
        let points = []
        let duration = 0
        let length = 0
        let fullWay
        fullWay = this.IsCycle
          ? [this.RLStartPoint, ...this.selectedPoints, this.RLStartPoint]
          : [this.RLStartPoint, ...this.selectedPoints]
        const testData = await getFullWay(fullWay)
        // const response = await getOptimizedPoints(fullWay);
        testData.route.legs.forEach(leg => {
          let legStep = []
          leg.steps.forEach(step => {
            length += step.length
            duration += step.duration
            legStep = legStep.concat(step.polyline.points.map(subArray => [...subArray].reverse()))
            // legStep = legStep.concat(step.polyline.points);
          })

          points.push(legStep)
        })

        length = (length / 1000).toFixed(2) // километры
        let hours = duration / 3600
        let minutes = Math.round((hours % 1) * 60)

        return {
          points,
          length: parseFloat(length),
          duration: {
            seconds: parseFloat(duration),
            timeString: `${Math.floor(hours)} ч. ${String(minutes).padStart(2, '0')} м.`
          }
        }
      } catch (error) {
        console.error('Ошибка при загрузке точек маршрута:', error)
        return {
          points: [],
          length: null,
          duration: null
        }
      }
    },
    async getTSPRoutePoints1 () {
      try {
        let points = []
        let duration = 0
        let length = 0
        let fullWay
        // fullWay = this.IsCycle
        //   ? [this.RLStartPoint, ...this.selectedPoints, this.RLStartPoint]
        //   : [this.RLStartPoint, ...this.selectedPoints]
        fullWay = [this.RLStartPoint, ...this.selectedPoints]
        const testData = await getTSPWay(fullWay)
        // const response = await getOptimizedPoints(fullWay);
        testData.route.legs.forEach(leg => {
          let legStep = []
          leg.steps.forEach(step => {
            length += step.length
            duration += step.duration
            legStep = legStep.concat(step.polyline.points.map(subArray => [...subArray].reverse()))
            // legStep = legStep.concat(step.polyline.points);
          })

          points.push(legStep)
        })

        length = (length / 1000).toFixed(2) // километры
        let hours = duration / 3600
        let minutes = Math.round((hours % 1) * 60)

        return {
          points,
          length: parseFloat(length),
          duration: {
            seconds: parseFloat(duration),
            timeString: `${Math.floor(hours)} ч. ${String(minutes).padStart(2, '0')} м.`
          }
        }
      } catch (error) {
        console.error('Ошибка при загрузке точек маршрута:', error)
        return {
          points: [],
          length: null,
          duration: null
        }
      }
    }
  }
})
